import React from "react";
import { Modal } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import "./ModalConfirmSelect.less";
import { useTranslation } from "react-i18next";

const ModalConfirmSelect = ({ visible, onConfirm, onCancel, slotData }) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={null}
            visible={visible}
            onOk={onConfirm}
            onCancel={onCancel}
            okText={t('modal.sendmail.confirm')}
            cancelText={t('modal.sendmail.cancel')}
            className="modal-confirm-select"
            centered
            width={480}
            okButtonProps={{
                className: "confirm-button",
                // icon: <CheckCircleOutlined />
            }}
            cancelButtonProps={{
                className: "cancel-button"
            }}
        >
            <div className="modal-content">
                <div className="modal-header">
                    <div className="icon-wrapper">
                        <EnvironmentOutlined className="location-icon" />
                    </div>
                    <h3 className="modal-title">{t('modal.sendmail.confirm-choose')}</h3>
                </div>

                <div className="modal-body">
                    <div className="selection-info">
                        <div className="info-item">
                            <span className="label">{t('modal.sendmail.property-code')}</span>
                            <span className="value">{slotData?.propertyNo}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">{t('modal.sendmail.floor')}</span>
                            <span className="value">{slotData?.parkingAreaName}</span>
                        </div>
                        {/* <div className="info-item">
                            <span className="label">{t('modal.sendmail.apartment')}</span>
                            <span className="value">{slotData?.apartment}</span>
                        </div> */}
                        <div className="info-item">
                            <span className="label">{t('modal.sendmail.price-vn')}</span>
                            <span className="value">{new Intl.NumberFormat("de-DE", { style: "currency", currency: "VND" }).format(slotData?.priceVN)}</span>
                        </div>
                        {/* <div className="info-item">
                            <span className="label">{t('modal.sendmail.price-foreign')}</span>
                            <span className="value">{new Intl.NumberFormat("de-DE", { style: "currency", currency: "USD" }).format(slotData?.priceForeign)}</span>
                        </div> */}
                        <div className="note info-item">
                            <span className="label">{t('modal.sendmail.description')}</span>
                            <span className="value">{t('modal.sendmail.note')}</span>
                        </div>
                    </div>

                    {/* <div className="warning-note">
                        <span>⚠️ Lựa chọn này sẽ được áp dụng cho phiên làm việc hiện tại</span>
                    </div> */}
                </div>
            </div>
        </Modal>
    );
};

export default ModalConfirmSelect;